import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('budget')

export class BudgetEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number;

    @Column('varchar', {
        name: 'budget_period',
        nullable: true
    })
    budgetPeriod: string;

    @Column('varchar', {
        name: 'from_date',
        nullable: true
    })
    fromDate: Date | string;


    @Column('varchar', {
        name: 'to_date',
        nullable: true
    })
    toDate: Date | string;

    @Column('int', {
        name: 'budget',
        nullable: true
    })
    budget: number;

    @Column('int', {
        name: 'departmentName',
        nullable: true
    })
    departmentName: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
  

}